<!--文本域，没有清空按钮-->
<template>
  <el-input
    type="textarea"
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :title="title"
    :clearable="clearable"
    @blur="run"
    @change="run"
    @clear="run"
    @keydown="clear"
  >
  </el-input>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // import { ElInput } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-from-item-area',
    inheritAttrs: false,
    components: {
      // ElInput
    },
    props: {
      modelValue: [String, Number],
      ...itemProps // 基础属性,
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      // console.log('多行文本框的属性：', props)
       /*
       value,
       run,
       clear
      */
      return {
        ...itemController(props, context.emit)
      }
    }
  })
</script>
